import env from '@/env';
export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 登录
     * @description http://yapi.xiya.vip/project/11/interface/api/10
     */
    USER_LOGIN: function USER_LOGIN(_ref2) {
      var _ref2$username = _ref2.username,
          username = _ref2$username === void 0 ? '' : _ref2$username,
          _ref2$password = _ref2.password,
          password = _ref2$password === void 0 ? '' : _ref2$password;
      return request({
        url: '/api/user/login',
        method: 'post',
        data: {
          username: username,
          password: password
        }
      });
    },

    /**
     * @description 注销
     * @description http://yapi.xiya.vip/project/11/interface/api/40
     */
    USER_LOGOUT: function USER_LOGOUT() {
      return request({
        url: '/api/user/logout',
        method: 'post'
      });
    },

    /**
     * @description Token 校验
     * @description http://yapi.xiya.vip/project/11/interface/api/15
     */
    USER_CHECK_TOKEN: function USER_CHECK_TOKEN() {
      return request({
        // url: env.VUE_APP_API_0_TEST + '/api/user/check_token',
        url: '/api/user/check_token',
        method: 'post'
      });
    },

    /**
     * @description 查询所有用户
     * @description http://yapi.xiya.vip/project/11/interface/api/30
     */
    USER_ALL: function USER_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/user/index',
        method: 'post',
        data: query
      });
    },

    /**
     * @description 用户创建
     * @description http://yapi.xiya.vip/project/11/interface/api/25
     */
    USER_CREATE: function USER_CREATE(data) {
      return request({
        url: '/api/user/create',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 用户详情
     * @description http://yapi.xiya.vip/project/11/interface/api/240
     */
    USER_DETAIL: function USER_DETAIL(id) {
      return request({
        url: '/api/user/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
     * @description 用户编辑
     * @description http://yapi.xiya.vip/project/11/interface/api/240
     */
    USER_UPDATE: function USER_UPDATE(data) {
      return request({
        url: '/api/user/update',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 用户删除
     * @description http://yapi.xiya.vip/project/11/interface/api/155
     */
    USER_DELETE: function USER_DELETE(id) {
      return request({
        url: '/api/user/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});